
import DocumentStoreStyles from "./Shimmer.module.scss";

const Shimmer = () => (
  <div className={DocumentStoreStyles.shimmerWrapper}>
    <div className={DocumentStoreStyles.shimmer}></div>
  </div>
);

export default Shimmer;
